import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './ActivateCdiForm.jsx'

export default createSubmit(name)